import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack, Box } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const AppAuthTenantIDField = ({ darkMode, errors = {}, touched = {}, values = {} }) => {
    const [isHovered, setIsHovered] = useState(false);
    
    const isReadOnly = !!(values?.tenantID); // Read-only if tenantID already has a value

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!(errors?.tenantID && touched?.tenantID)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Tenant ID {!isReadOnly && <span style={{ color: '#e53e3e' }}>*</span>}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        {isReadOnly ? 'Tenant ID is populated and read-only.' : 'Enter the Microsoft Azure Tenant ID.'}
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            name="tenantID"
                            id="tenantID"
                            placeholder={isReadOnly ? 'Auto-populated' : 'Enter Tenant ID'}
                            isDisabled={isReadOnly}
                            readOnly={isReadOnly}
                            validate={value => !isReadOnly && !value && 'Tenant ID is required'}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={isReadOnly ? 'Tenant ID is automatically populated and cannot be changed' : 'Enter your Microsoft Azure Tenant ID'}
                        ariaLabel="tenant-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthTenantIDField;